export default __webpack_public_path__ + "static/media/004-A-mutuelle.c1fff996.svg";